import {
  Add_Leads_Stages_Type,
  Delete_Leads_Stages_Type,
  Get_All_Leads_Stages_Type,
  Get_Error,
  Get_One_Leads_Stages_Type,
  Update_One_Leads_Stages_Type,
} from '../Types';

const intial = {
  Lead_Stages_changed: [],

  loading: true,
};
export const Lead_Stages_Changed_Reducers = (state = intial, action) => {
  switch (action.type) {
    case Add_Leads_Stages_Type:
      return {
        Lead_Stages_changed: action.payload,
        loading: false,
      };
    case Get_All_Leads_Stages_Type:
      return {
        ...state,
        Lead_Stages_changed: action.payload,
        loading: false,
      };
    case Update_One_Leads_Stages_Type:
      return {
        ...state,
        Lead_Stages_changed: action.payload,
        loading: false,
      };
    case Delete_Leads_Stages_Type:
      return {
        ...state,
        Lead_Stages_changed: action.payload,
        loading: false,
      };
    case Get_One_Leads_Stages_Type:
      return {
        ...state,
        Lead_Stages_changed: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Developers: action.payload,
      };
    default:
      return state;
  }
};
